import styled from 'styled-components';

import { MAX_WIDTH } from '../../../constants';

export const FrameWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Frame = styled.div<{ fullWidth: boolean }>`
  width: ${(props) => (props.fullWidth ? '100%' : MAX_WIDTH)};

  box-sizing: border-box;
  padding: 25px 32px;
  border-radius: ${(props) => props.theme.misc.borderRadiusMd};
  border: 1px solid ${(props) => props.theme.colors.stroke};
  div:last-child {
    margin-bottom: 0px;
  }
`;
